import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tributario/contribuinteatividade/';

class ContribuinteAtividadeService {
    constructor() {
        this.idCliente = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllAtividades(idContribuinte) {
        return axios.get(API_URL + 'all?idContribuinte='+idContribuinte, {headers: this.headers});
    }

    findAllAtividadesByContribuinteFiltro(filtro, idContribuinte) {
        return axios.get(API_URL + 'filter?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    findAllAtividadesByServicoVinc(filtro, idContribuinte) {
        return axios.get(API_URL + 'filterAtividadeServico?filtro='+filtro+'&idContribuinte='+idContribuinte, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    findAllAtividadesByAtividadeFiltro(filtro, idContribuinte, idAtividade) {
        return axios.get(API_URL + 'filterServicoAtividade?idContribuinte='+idContribuinte+'&idAtividade='+idAtividade+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    
    
}

export default new ContribuinteAtividadeService();